import EmbedCodeGenerator from '../../utils/embed';
import { AllowSocial } from '../../utils/allow-social';
import { ensureHttpOnProtocolRelativeUrl } from '../../utils/broadcast';
import DownloadOrExportHighlightController from './modal-download-or-export-highlight';

export default function HighlightPreviewController(
  /* injected via normal angular DI */
  $uibModal,
  $uibModalInstance,
  Highlight,
  ConfirmDialog,
  toaster,
  $rootScope,
  $timeout,
  /* injected via `resolve` arguments to modal */
  broadcast,
  highlightDetails,
  showSave
) {
  'ngInject';

  this.FeatureFlags = $rootScope.account.feature_flags;
  this.Highlight = Highlight;
  this.ConfirmDialog = ConfirmDialog;
  this.toaster = toaster;
  this.highlight = highlightDetails;
  this.mediaTokenRestrictions = $rootScope.account.extra_features.media_token_restrictions;
  this.broadcast = broadcast;
  this.broadcastIsMonetized = !broadcast.is_private && broadcast.is_ticketed;
  this.highlightCanBeShared =
    !this.mediaTokenRestrictions &&
    (!this.broadcastIsMonetized || this.highlight.duration <= MAX_MONETIZED_HIGHLIGHT_TIME_S);
  this.showSave = showSave;
  this.showPlayer = true;
  this.showEmbed = false;
  this.embedCode = EmbedCodeGenerator.highlightClipEmbed(this.highlight.id, {});
  this.showSocialShare =
    this.highlightCanBeShared && AllowSocial(this.FeatureFlags, $rootScope.account, this.broadcast);

  this.limits = $rootScope.ApiConfig.modelFieldLimits('highlight', 'maximum');

  if (highlightDetails.id) {
    this.channelId = highlightDetails.id;
    this.mode = 'highlight';
    this.options = {
      autoplay: true,
      showSocialShare: this.showSocialShare,
      selectedBroadcastId: broadcast.id,
      ticketId: broadcast.admin_token,
    };
  } else {
    this.channelId = broadcast.channel_id;
    this.mode = 'channel';
    this.options = {
      autoplay: true,
      showSocialShare: false, //disable built-in sharing bc we're faking the highlight
      trimSeconds: {
        start: highlightDetails.start_seconds,
        stop: highlightDetails.stop_seconds,
      },
      ticketId: broadcast.admin_token,
    };
  }

  this.save = () =>
    $uibModalInstance.close({
      name: this.highlight.name,
      start_seconds: this.options.trimSeconds.start,
      stop_seconds: this.options.trimSeconds.stop,
    });
  this.cancel = () => $uibModalInstance.dismiss('cancel');

  this.link = `${BOXCAST_TV_HIGHLIGHT_URL}${this.broadcast.channel_id}/${this.broadcast.id}/${this.highlight.id}`;
  var broadcastAbbrev = broadcast.name || '';
  if (broadcastAbbrev.length > 15) {
    broadcastAbbrev = broadcastAbbrev.substring(0, 12) + '...';
  }

  var description = highlightDetails.description || `Highlight from ${broadcastAbbrev}`;
  this.tweet = () => {
    let url = escape(this.link);
    let text = escape(`Watch ${highlightDetails.name} (${description}) at `);
    window.open(
      'http://twitter.com/share?url=' + url + '&text=' + text,
      'Promote on Twitter',
      'dependent=1,height=400,width=600,resizable=1'
    );
  };

  this.facebook = () => {
    // Use the graph API directly since we don't have proper opengraph
    // headers on our show page.
    // https://developers.facebook.com/docs/graph-api/reference/v2.4/post
    let previewImg = highlightDetails.preview;
    if (!previewImg) {
      previewImg = `${IMG_ROOT}boxcast_social_play_square.png`;
    }

    FB.ui(
      {
        method: 'share',
        href: this.link,
        title: highlightDetails.name,
        name: highlightDetails.name,
        description: description,
        picture: ensureHttpOnProtocolRelativeUrl(previewImg),
        caption: 'BoxCast :: a smarter way to stream',
        type: 'video',
        display: 'popup',
      },
      function (response) {}
    );
  };

  this.nudge = (side, offset) => {
    var seconds = Math.max(this.options.trimSeconds[side] + offset, 0);
    // Need to leave at least a 1-second gap so the bounds are valid.
    if (side === 'stop') {
      seconds = Math.max(seconds, this.options.trimSeconds['start'] + 1);
    } else if (side === 'start') {
      seconds = Math.min(seconds, this.options.trimSeconds['stop'] - 1);
    }
    this.options.trimSeconds[side] = seconds;
    this.showPlayer = false;
    $timeout(() => (this.showPlayer = true), 10);
  };

  this.delete = () => {
    const { Highlight, ConfirmDialog } = this;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Delete Highlight',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText: 'Are you sure you want to permanently delete this highlight?',
    };

    ConfirmDialog.show(modalOptions).then(() => {
      Highlight.delete(
        { id: this.highlight.id, broadcastId: this.broadcast.id },
        () => {
          this.toaster.pop('warning', 'Successfully deleted highlight');
          this.cancel();
        },
        () => alert('Error deleting highlight. Please reload this page and try again.')
      );
    });
  };

  this.download = () => {
    $uibModal.open({
      template: require('./modal-download-or-export-highlight.html'),
      controllerAs: 'vm',
      controller: DownloadOrExportHighlightController,
      resolve: {
        broadcast: () => this.broadcast,
        highlight: () => this.highlight,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./app/pages/events/modal-highlight-preview.js